/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useState } from "react";

export interface ValidationProps {
  minLength?: number;
  maxLength?: number;
  regExVal?: RegExp;
  lengthErrorMsg?: string;
  regexErrorMsg?: string;
}

interface InputProps {
  inputType: string;
  className: string;
  placeHolder: string;
  value: string;
  validProps: ValidationProps;
  handleChange(s: string): void;
  setValidity?(b: boolean): void;
}

function HmsInput({
  inputType,
  className,
  placeHolder,
  value,
  validProps,
  handleChange,
  setValidity,
}: InputProps) {
  const [errorMsg, setErrorMsg] = useState<string>("");

  function executeValidation(val: string) {
    if (
      validProps.minLength &&
      validProps.maxLength &&
      validProps.lengthErrorMsg
    ) {
      if (
        val.length > validProps.maxLength ||
        val.length < validProps.minLength
      ) {
        setErrorMsg(validProps.lengthErrorMsg);
        return false;
      }
    }
    if (validProps.regExVal && validProps.regexErrorMsg) {
      if (!validProps.regExVal.test(val)) {
        setErrorMsg(validProps.regexErrorMsg);
        return false;
      }
    }
    setErrorMsg("");
    return true;
  }

  function handleChangeFunc(val: string) {
    if (executeValidation(val)) {
      setValidity && setValidity(true);
    } else {
      setValidity && setValidity(false);
    }
    handleChange(val);
  }

  return (
    <>
      {inputType === "textarea" ? (
        <textarea
          className={className}
          placeholder={placeHolder}
          value={value}
          onChange={(e) => {
            e.preventDefault();
            handleChangeFunc(e.target.value);
          }}
        />
      ) : (
        <input
          className={className}
          type="text"
          value={value}
          onChange={(e) => {
            e.preventDefault();
            handleChangeFunc(e.target.value);
          }}
        />
      )}
      <div className="error-message text-primary p-3">{errorMsg}</div>      
    </>
  );
}

export default HmsInput;
